<section class="rpl">
  <header class="rpl-header">
    <div class="rpl-title-block">
      <h1 class="rpl-title">{{ title }}</h1>
      <div class="rpl-title-meta">
        <span class="rpl-ay" *ngIf="academicYearLabel">{{ academicYearLabel }}</span>
        <span class="rpl-row-count" *ngIf="rows?.length != null">
          <strong>{{ rows.length }}</strong>
          <span>{{ rows.length === 1 ? 'row' : 'rows' }}</span>
        </span>
      </div>
    </div>

    <div class="rpl-actions">
      <button type="button" class="secondary-btn rpl-act" (click)="onRefreshClick()" [disabled]="loading" title="Refresh">
        <i class="bi bi-arrow-clockwise"></i>
        <span>Refresh</span>
      </button>

      <app-column-picker [reportSlug]="reportSlug"
                         [columns]="columns"
                         (visibilityChange)="onVisibilityChange($event)">
      </app-column-picker>

      <button type="button" class="secondary-btn rpl-act"
              *ngIf="filterDefs.length > 0 || showMandatoryFilter"
              (click)="openFilterPanel()"
              title="Advanced Filters">
        <i class="bi bi-sliders"></i>
        <span>Filters<span class="fp-badge" *ngIf="activeRuleCount > 0"> {{ activeRuleCount }}</span></span>
      </button>

      <button type="button" class="secondary-btn rpl-act" (click)="exportXlsx()" [disabled]="!rows?.length" title="Export Excel">
        <i class="bi bi-file-earmark-excel"></i>
        <span>Excel</span>
      </button>

      <button type="button" class="secondary-btn rpl-act" (click)="exportCsv()" [disabled]="!rows?.length" title="Export CSV">
        <i class="bi bi-file-earmark-text"></i>
        <span>CSV</span>
      </button>

      <button type="button" class="primary-button rpl-act" *ngIf="showEmail" (click)="openEmailDialog()" [disabled]="!rows?.length || emailing" title="Email Report">
        <i class="bi bi-envelope"></i>
        <span>{{ emailing ? 'Sending…' : 'Email' }}</span>
      </button>

      <!-- Favourite button — only shown when moduleName is wired up -->
      <ng-container *ngIf="enableFavourite && moduleName">
        <button type="button"
                class="secondary-btn rpl-act rpl-fav-btn"
                [class.rpl-fav-btn-active]="isFavourite"
                (click)="onFavouriteClick()"
                [title]="isFavourite ? 'Remove from favourites' : 'Add to favourites'">
          <i class="bi" [class.bi-star-fill]="isFavourite" [class.bi-star]="!isFavourite"></i>
          <span>{{ isFavourite ? 'Favourited' : 'Favourite' }}</span>
        </button>
        <!-- "Save another config" button shown when already a favourite -->
        <button type="button"
                *ngIf="isFavourite"
                class="secondary-btn rpl-act"
                (click)="favConfigName = reportName || title; showFavNamePrompt = true"
                title="Save current settings as a named favourite configuration">
          <i class="bi bi-bookmark-plus"></i>
          <span>Save Config</span>
        </button>
      </ng-container>
    </div>
  </header>

  <!-- Inline "name your favourite config" prompt -->
  <div class="rpl-fav-prompt" *ngIf="showFavNamePrompt">
    <i class="bi bi-star-fill rpl-fav-prompt-icon"></i>
    <span class="rpl-fav-prompt-label">Config name:</span>
    <input class="rpl-fav-prompt-input form-control form-control-sm"
           type="text"
           [value]="favConfigName"
           (input)="favConfigName = $any($event.target).value"
           placeholder="e.g. Pending Students – Class 5"
           (keydown.enter)="isFavourite ? saveAnotherFavouriteConfig() : saveAsFavourite()"
           (keydown.escape)="cancelFavPrompt()" />
    <button class="primary-button btn-sm" (click)="isFavourite ? saveAnotherFavouriteConfig() : saveAsFavourite()">Save</button>
    <button class="secondary-btn btn-sm" (click)="cancelFavPrompt()">Cancel</button>
  </div>

  <div class="rpl-banner" *ngIf="infoBanner">
    <i class="bi bi-info-circle"></i>
    <span>{{ infoBanner }}</span>
  </div>

  <div class="rpl-banner rpl-banner-warn" *ngIf="dateWarning">
    <i class="bi bi-exclamation-triangle-fill"></i>
    <span>{{ dateWarning }}</span>
  </div>

  <section class="rpl-filters">
    <div class="row align-items-end">
      <div class="col-md-2 spaceDivBottom mainAllSpace" *ngIf="showAcademicYearFilter">
        <label class="form-label">Academic Year</label>
        <select class="form-select formMainSelectdiv"
                [value]="academicYearId"
                (change)="onAcademicYearPick($any($event.target).value)">
          <option *ngFor="let ay of academicYearList"
                  [value]="ay.academicYearId ?? ay.id ?? ay.AcademicYearId">
            {{ ay.description ?? ay.name }}
          </option>
        </select>
      </div>

      <ng-content select="[reportFilters]"></ng-content>

      <app-date-filter *ngIf="showDateFilter"
                       [defaultMode]="defaultDateMode"
                       [academicYearStart]="academicYearStart"
                       [academicYearEnd]="academicYearEnd"
                       (rangeChange)="onDateRangeChange($event)">
      </app-date-filter>

      <div class="col-md-auto spaceDivBottom mainAllSpace" *ngIf="showClearFilter">
        <label class="form-label rpl-clear-spacer">&nbsp;</label>
        <app-clear-filters
          [filters]="currentFilters"
          [enabled]="true"
          (cleared)="onClearFiltersClick()">
        </app-clear-filters>
      </div>
    </div>
  </section>

  <section class="rpl-grid">
    <ag-grid-angular
      class="ag-theme-quartz rpl-aggrid"
      [gridOptions]="gridOptions"
      [columnDefs]="colDefs"
      [rowData]="gridRowData"
      [pagination]="true"
      [paginationPageSize]="paginationPageSize"
      [paginationPageSizeSelector]="paginationPageSizeSelector"
      [rowSelection]="rowSelection"
      (gridReady)="onGridReady($event)">
    </ag-grid-angular>
  </section>
</section>

<app-filter-panel
  *ngIf="filterDefs.length > 0 || showMandatoryFilter"
  [defs]="filterDefs"
  [rows]="allRows.length ? allRows : rows"
  [open]="filterPanelOpen"
  [appliedRules]="lastAppliedRules"
  [showMandatory]="showMandatoryFilter"
  [mandatoryValue]="mandatoryValue"
  (mandatoryChange)="mandatoryChange.emit($event)"
  (rulesApplied)="onPanelRulesApplied($event)"
  (closed)="onFilterPanelClosed()">
</app-filter-panel>
